export const CLASSNAME = 'text-style-b text-neutral-900';

export const TITLE = 'Loans';
